module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nlet field, fieldProperties, renderGranted\nif(formMapping.modelFieldIndex >= 0 && model.fields && (field = model.fields[formMapping.modelFieldIndex]) && field.atom){\nfieldProperties = (model.fieldProperties || {})[field.fieldCode || '~~~NOT_EXISTING_FIELD~~~'] || {}\nrenderGranted = field.atom.renderType && field.atom.renderType != 'none' && !fieldProperties.preventRender\nif(renderGranted){\nvar fieldConfig = field.config || {};\nvar formBasePath = '../';\nvar fieldPath = '';\nvar hidden = false;\nvar disabled = false;\nvar isFilterField = false;\nvar preventFieldLabel = Boolean(config.preventAllFieldLabels);\nvar additionalClasses = '';\nif(formMapping.fieldConfig){\nif(formMapping.fieldConfig.hidden || fieldConfig.hidden){\nhidden = true;\n}\nif(formMapping.fieldConfig.disabled || fieldConfig.disabled){\ndisabled = true;\n}\nif(formMapping.fieldConfig.isFilterField){\nisFilterField = true;\n}\nif(formMapping.fieldConfig.preventFieldLabel || fieldConfig.preventFieldLabel){\npreventFieldLabel = true;\n}\nif(formMapping.fieldConfig.additionalClasses || fieldConfig.additionalClasses){\nadditionalClasses = formMapping.fieldConfig.additionalClasses;\n}\nif(formMapping.fieldConfig.fieldPath){\nfieldPath = '../../../' + formMapping.fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n}\n}\nif(fieldConfig.formBasePath){\nformBasePath = '../../../' + String(fieldConfig.formBasePath).replace(/^\\//, '').replace(/\\/$/, '') + '/';\n}\nif(!fieldPath){\nif(fieldConfig.fieldPath){\nfieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\\//, '').replace(/\\/$/, '');\n} else if(field.atom.renderType !== 'custom') {\nfieldPath = formBasePath + 'fields/' + field.atom.renderType;\n}\n}\npreventFieldLabel = preventFieldLabel || isFilterField || fieldConfig.preventFieldLabel;\nfield.label = '';\nfield.description = '';\nfield.information = '';\nfield.placeholder = '';\nif((field.lang || {})[(storage || {}).langCode || 'MISSING_LANG_CODE']){\nconst currentLangData = field.lang[storage.langCode];\nif(currentLangData.label){\nfield.label = currentLangData.label;\nfield.placeholder = currentLangData.label;\n}\nif(currentLangData.description){\nfield.description = currentLangData.description;\n}\nif(currentLangData.information){\nfield.information = currentLangData.information;\n}\nif(currentLangData.info){\nfield.information = currentLangData.info;\n}\n}\nif(formMapping.labelKey){\nfield.label = storage.__(formMapping.labelKey);\nfield.placeholder = field.label;\n}\nif(isFilterField){\nfield.placeholder = storage.__('filter') + ' ' + field.placeholder;\n}\nif(!config.isFieldCodeSelector || !field.preventFieldCodeSelection){\nlet fieldModel = field\nif(config.isFieldCodeSelector){\ndisabled = !config.preventFieldCodeSelectorFields\n%><div class=\"fieldWrapper fieldCodeSelector\"><%\n%><div class=\"control\"><%- include('../fields/toggleFieldCode', { model: { fieldCode: `wrapper_${field.fieldCode}`, dataINT: field.dataINT, config: { slimSwitch: true }}}) %></div><%\n%><div class=\"element\"><%\ndelete fieldModel.dataINT\n}\n%><div class=\"field<%= (disabled ? ' disabled' : '') %><%= (hidden ? ' hidden' : '') %><%= (additionalClasses ? ' ' + additionalClasses : '') %> fieldOf_<%- field.fieldCode %>\"><%\nif(fieldPath && !hidden){\nif(config.isFullyVertical){\n%><div class=\"labelContainer\"><%\n}\nif(!preventFieldLabel){\n%><%- include('label', { formMapping: formMapping, model: field }); %><%\n}\n// checkboxes use the description as text right of the checkbox itself which conflicts with the tooltip (which is rendered according to the description field too).\nif(field.description && field.atom.renderType !== 'checkbox'){\n%><%- include('../../tooltip/tooltip', { model: { message: field.description }, config: { ...(fieldConfig.tooltip || {}), additionalClasses: ['fieldIndependent', `renderType_${field.atom.renderType}`] } }); %><%\n}\nif(config.isFullyVertical){\n%></div><%\n}\nif(!config.isFieldCodeSelector || !config.preventFieldCodeSelectorFields){\nconst componentConfig = fieldConfig.componentConfig || {}\nif(fieldConfig.secureRoute){\ncomponentConfig.secureRoute = fieldConfig.secureRoute\n}\nif(fieldConfig.secureRouteHash){\ncomponentConfig.secureRouteHash = fieldConfig.secureRouteHash\n}\n%><%- include(fieldPath, { formMapping, model: field, config: componentConfig }); %><%\n}\n} else {\n%><span class=\"hidden-<%- field.fieldCode %>\"></span><%\n}\n%></div><%\nif(config.isFieldCodeSelector){\n%></div><%\n%></div><%\n}\n}\n}\nelse {\n%><span class=\"hidden-<%- field.fieldCode %>\"></span><%\n}\n}\n// // TODO: render static fields\n// else {\n//     const renderType = formMapping.renderType;\n//     const fieldCode = formMapping.fieldCode;\n//     const fieldConfig = formMapping.fieldConfig || {};\n//     const fieldPath = '../fields/' + renderType;\n//     const fieldModel = {\n//         fieldCode,\n//         additionalCSSClass: (fieldConfig.additionalClasses || []).join(' ')\n//     }\n//\n//     if(renderType && fieldCode){\n//        %><%#- include(fieldPath, { formMapping: formMapping, model: fieldModel }); %><%\n//     }\n// }\n%>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\elements\\field.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
let field, fieldProperties, renderGranted
if(formMapping.modelFieldIndex >= 0 && model.fields && (field = model.fields[formMapping.modelFieldIndex]) && field.atom){
fieldProperties = (model.fieldProperties || {})[field.fieldCode || '~~~NOT_EXISTING_FIELD~~~'] || {}
renderGranted = field.atom.renderType && field.atom.renderType != 'none' && !fieldProperties.preventRender
if(renderGranted){
var fieldConfig = field.config || {};
var formBasePath = '../';
var fieldPath = '';
var hidden = false;
var disabled = false;
var isFilterField = false;
var preventFieldLabel = Boolean(config.preventAllFieldLabels);
var additionalClasses = '';
if(formMapping.fieldConfig){
if(formMapping.fieldConfig.hidden || fieldConfig.hidden){
hidden = true;
}
if(formMapping.fieldConfig.disabled || fieldConfig.disabled){
disabled = true;
}
if(formMapping.fieldConfig.isFilterField){
isFilterField = true;
}
if(formMapping.fieldConfig.preventFieldLabel || fieldConfig.preventFieldLabel){
preventFieldLabel = true;
}
if(formMapping.fieldConfig.additionalClasses || fieldConfig.additionalClasses){
additionalClasses = formMapping.fieldConfig.additionalClasses;
}
if(formMapping.fieldConfig.fieldPath){
fieldPath = '../../../' + formMapping.fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
}
}
if(fieldConfig.formBasePath){
formBasePath = '../../../' + String(fieldConfig.formBasePath).replace(/^\//, '').replace(/\/$/, '') + '/';
}
if(!fieldPath){
if(fieldConfig.fieldPath){
fieldPath = '../../../' + fieldConfig.fieldPath.replace(/^\//, '').replace(/\/$/, '');
} else if(field.atom.renderType !== 'custom') {
fieldPath = formBasePath + 'fields/' + field.atom.renderType;
}
}
preventFieldLabel = preventFieldLabel || isFilterField || fieldConfig.preventFieldLabel;
field.label = '';
field.description = '';
field.information = '';
field.placeholder = '';
if((field.lang || {})[(storage || {}).langCode || 'MISSING_LANG_CODE']){
const currentLangData = field.lang[storage.langCode];
if(currentLangData.label){
field.label = currentLangData.label;
field.placeholder = currentLangData.label;
}
if(currentLangData.description){
field.description = currentLangData.description;
}
if(currentLangData.information){
field.information = currentLangData.information;
}
if(currentLangData.info){
field.information = currentLangData.info;
}
}
if(formMapping.labelKey){
field.label = storage.__(formMapping.labelKey);
field.placeholder = field.label;
}
if(isFilterField){
field.placeholder = storage.__('filter') + ' ' + field.placeholder;
}
if(!config.isFieldCodeSelector || !field.preventFieldCodeSelection){
let fieldModel = field
if(config.isFieldCodeSelector){
disabled = !config.preventFieldCodeSelectorFields

    ; __line = 77
    ; __append("<div class=\"fieldWrapper fieldCodeSelector\">")
    ; 

    ; __line = 78
    ; __append("<div class=\"control\">")
    ; __append( include('../fields/toggleFieldCode', { model: { fieldCode: `wrapper_${field.fieldCode}`, dataINT: field.dataINT, config: { slimSwitch: true }}}) )
    ; __append("</div>")
    ; 

    ; __line = 79
    ; __append("<div class=\"element\">")
    ; 
delete fieldModel.dataINT
}

    ; __line = 82
    ; __append("<div class=\"field")
    ; __append(escapeFn( (disabled ? ' disabled' : '') ))
    ; __append(escapeFn( (hidden ? ' hidden' : '') ))
    ; __append(escapeFn( (additionalClasses ? ' ' + additionalClasses : '') ))
    ; __append(" fieldOf_")
    ; __append( field.fieldCode )
    ; __append("\">")
    ; 
if(fieldPath && !hidden){
if(config.isFullyVertical){

    ; __line = 85
    ; __append("<div class=\"labelContainer\">")
    ; 
}
if(!preventFieldLabel){

    ; __line = 88
    ; __append( include('label', { formMapping: formMapping, model: field }) )
    ; 
}
// checkboxes use the description as text right of the checkbox itself which conflicts with the tooltip (which is rendered according to the description field too).
if(field.description && field.atom.renderType !== 'checkbox'){

    ; __line = 92
    ; __append( include('../../tooltip/tooltip', { model: { message: field.description }, config: { ...(fieldConfig.tooltip || {}), additionalClasses: ['fieldIndependent', `renderType_${field.atom.renderType}`] } }) )
    ; 
}
if(config.isFullyVertical){

    ; __line = 95
    ; __append("</div>")
    ; 
}
if(!config.isFieldCodeSelector || !config.preventFieldCodeSelectorFields){
const componentConfig = fieldConfig.componentConfig || {}
if(fieldConfig.secureRoute){
componentConfig.secureRoute = fieldConfig.secureRoute
}
if(fieldConfig.secureRouteHash){
componentConfig.secureRouteHash = fieldConfig.secureRouteHash
}

    ; __line = 105
    ; __append( include(fieldPath, { formMapping, model: field, config: componentConfig }) )
    ; 
}
} else {

    ; __line = 108
    ; __append("<span class=\"hidden-")
    ; __append( field.fieldCode )
    ; __append("\"></span>")
    ; 
}

    ; __line = 110
    ; __append("</div>")
    ; 
if(config.isFieldCodeSelector){

    ; __line = 112
    ; __append("</div>")
    ; 

    ; __line = 113
    ; __append("</div>")
    ; 
}
}
}
else {

    ; __line = 118
    ; __append("<span class=\"hidden-")
    ; __append( field.fieldCode )
    ; __append("\"></span>")
    ; 
}
}
// // TODO: render static fields
// else {
//     const renderType = formMapping.renderType;
//     const fieldCode = formMapping.fieldCode;
//     const fieldConfig = formMapping.fieldConfig || {};
//     const fieldPath = '../fields/' + renderType;
//     const fieldModel = {
//         fieldCode,
//         additionalCSSClass: (fieldConfig.additionalClasses || []).join(' ')
//     }
//
//     if(renderType && fieldCode){
//        

    ; __line = 133
    ; 
//     }
// }

    ; __line = 136
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\elements\field.ejs

}